import { Component } from '@angular/core';
import { FieldType } from '@ngx-formly/core';

@Component({
    selector: 'lockton-apps-divider-type',
    template: ``,
    standalone: false
})
export class HiddenTypeComponent extends FieldType {}
